import { useEffect, useState } from "react";
import { axiosInstance } from "../../../utils/axiosInstance";
import { useStyles } from "./modalContent";

const ReusableModal = ({ isOpen, onClose, mode, providerData, onSubmit, onDelete }) => {
  const classes = useStyles();
  const [healthPlans, setHealthPlans] = useState([]);
  const [formData, setFormData] = useState({
    name: providerData?.name || "",
    location: providerData?.location || "",
    address: providerData?.address || "",
    health_plan_id: providerData?.health_plan_id || "",
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHealthPlans = async () => {
      try {
        const response = await axiosInstance.get(`/v1/admin/healthplans`);
        setHealthPlans(response?.data?.data || []);
      } catch (error) {
        setError("Failed to load health plans.", error);
      }
    };
    fetchHealthPlans();
  }, []);

  // Update formData when providerData changes
  useEffect(() => {
    if (providerData && (mode === "edit")) {
      setFormData({
        name: providerData.name || "",
        location: providerData.location || "",
        address: providerData.address || "",
        health_plan_id: providerData.health_plan_id?.toString() || "", // Convert to string for select input
      });
    } else {
      // Reset formData for create mode
      setFormData({
        name: "",
        location: "",
        address: "",
        health_plan_id: "",
      });
    }
  }, [providerData, mode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (
      !formData.name ||
      !formData.location ||
      !formData.address ||
      !formData.health_plan_id
    ) {
      setError("All fields are required.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    setError(null);
    if ((mode === "edit" || mode === "create") && !validateForm()) return;

    try {
      if (mode === "edit") {
        await onSubmit(providerData.id, formData);
      } else if (mode === "create") {
        await onSubmit(null, formData);
      } else if (mode === "delete") {
        await onDelete(providerData.id);
      }
      onClose();
    } catch (err) {
      setError("Operation failed. Please try again.");
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: "1000",
      }}
    >
      <div
        style={{
          background: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "500px",
          boxShadow: "0 8px 10px rgba",
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <h2>
          {mode === "edit"
            ? "Edit Provider"
            : mode === "create"
            ? "Create Provider"
            : "Delete Provider"}
        </h2>
        {error && <p style={{ color: "red" }}>{error}</p>}

        {(mode === "edit" || mode === "create") && (
          <form>
            <div>
              <label className={classes.enroleeIdText}>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Location:</label>
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Address:</label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              />
            </div>
            <div>
              <label className={classes.enroleeIdText}>Health Plan:</label>
              <select
                name="health_plan_id"
                value={formData.health_plan_id}
                onChange={handleChange}
                className={classes.enroleeInputId}
                required
              >
                <option value="">Select a health plan</option>
                {healthPlans?.map((plan) => (
                  <option key={plan?.id} value={plan?.id}>
                    {plan?.name || `Plan ${plan?.id}`}
                  </option>
                ))}
              </select>
            </div>
          </form>
        )}

        {mode === "delete" && (
          <p>Are you sure you want to delete {providerData?.name}?</p>
        )}

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              background: "#ccc",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            style={{
              padding: "8px 16px",
              background: mode === "delete" ? "#d32f2f" : "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            {mode === "edit" ? "Save" : mode === "create" ? "Create" : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReusableModal;